module.exports = __webpack_public_path__ + "img/logo-ontc-colour.3b1ae3a6.png";